import { Container, LeftContainer, NavButton, RightContainer } from './styles'

interface INavLink {
  to: string
  linkTitle: string
  exact?: boolean
}

interface INavBarProps {
  title: string
  navLinks: INavLink[]
}

export const NavBar: React.FC<INavBarProps> = ({ title, navLinks }) => {
  return (
    <Container>
      <LeftContainer>
        <img src={'https://sigah.blob.core.windows.net/onboard/icones/hierarchical_11804536 %281%29_0e8ce1cc-ef0b-45b4-b3f1-e5e29fb26ed3.png'} alt="icone" />

        <h2>{title}</h2>
      </LeftContainer>

      <RightContainer>
        {navLinks.map((navLink) => (
          <NavButton key={navLink.to} to={navLink.to} >
            <span>{navLink.linkTitle}</span>
          </NavButton>
        ))}
      </RightContainer>
    </Container>
  )
}
